import CreateTransportation from "components/ManageTransportaition/CreateTransportation";
import NotFooterLayout from "layouts/NotFooterLayout";
 

function CreateTransportationPage() {

  return (
    <NotFooterLayout namePage="เพิ่มขนส่ง" >
      <div className="layout-content">
        <CreateTransportation />
      </div>
    </NotFooterLayout>
  );
}

export default CreateTransportationPage;